export default {
  init() {
    // JavaScript to be fired on the home page
    console.log('vardaga-website home.js LOADED');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
